// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalPDF_modal__1Ju6u","title":"ModalPDF_title__3Q-B1"};